import { AvailabilityStates } from '@coolblue-development/next-availability-state';
import { Product } from '@features/product/typings';

export const getNumberOfStoresAvailable = (product: Product) => {
  return (
    product?.storeAvailabilities?.filter(
      item =>
        item.availabilityState === AvailabilityStates.OnStock ||
        item.availabilityState === AvailabilityStates.PreOrder
    ).length || 0
  );
};
